import clsx from 'clsx';
import { graphql } from 'gatsby';
import { useFormContext } from 'react-hook-form';

import { valueToLowerCase } from '../utils/helpers';
import InputWrapper from './InputWrapper';

const Multiselect = ({ fieldData, name, ...wrapProps }) => {
  const { choices, cssClass, id, isRequired, size } = fieldData;
  const options = JSON.parse(choices);

  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <InputWrapper
      errors={errors?.[name] || {}}
      inputData={fieldData}
      labelFor={name}
      {...wrapProps}
    >
      <select
        //TODO: GF uses select2 library and classes, need to figure out how to handle here if we're mimicing their functionality
        className={clsx(
          'gravityform__field__input__select',
          'gfield_select',
          cssClass,
          valueToLowerCase(size),
        )}
        id={name}
        multiple={true}
        name={name}
        {...register(name, {
          required: isRequired,
        })}
      >
        {options.map(({ isSelected, text, value }, index) => {
          return (
            <option
              defaultValue={isSelected}
              key={`${id}_${index}`}
              value={value}
            >
              {text}
            </option>
          );
        })}
      </select>
    </InputWrapper>
  );
};

export default Multiselect;

export const MultiSelectField = graphql`
  fragment MultiSelectField on WpMultiSelectField {
    adminLabel
    canPrepopulate
    choices {
      isSelected
      text
      value
    }
    conditionalLogic {
      ...ConditionalLogic
    }
    cssClass
    description
    descriptionPlacement
    hasChoiceValue
    hasEnhancedUI
    errorMessage
    inputName
    isRequired
    label
    size
    values
  }
`;
